import React, {SyntheticEvent, useEffect, useRef, useState} from 'react';

import {Checkbox} from 'components/ui-kit/Checkbox';

import {InputLabel} from './InputLabel';
import {AddressSpan, CheckboxItemLine, Container, Root, SearchWrapper} from './styled';

// import {Indicator, Label, NativeInput, Root} from './styled';

interface CheckboxProps {
    name: string;
    searchable?: boolean;
    placeholder?: string;
    value?: string[];
    options: (() => Record<string, string>[]) | Record<string, string>[];
    onChange?: (selected: string[] | undefined) => void;
}

export const CheckboxArray = ({
    name,
    placeholder,
    searchable = false,
    value = [],
    options,
    onChange,
}: CheckboxProps) => {
    const isFirstOptionsMount = useRef(true);
    const optionsHolder = useRef<Record<string, string>[]>(
        Array.isArray(options) ? options : options(),
    );

    const [selectedOptions, setSelectedOptions] = useState<string[] | undefined>(value);
    const [searchOptions, setOptions] = useState<Record<string, string>[]>(
        Array.isArray(options) ? options : options(),
    );

    useEffect(() => {
        optionsHolder.current = Array.isArray(options) ? options : options();
        setOptions(Array.isArray(options) ? options : options());

        if (isFirstOptionsMount.current) {
            isFirstOptionsMount.current = false;
        } else {
            setSelectedOptions(undefined);
        }
    }, [options]);

    function searchByCheckboxes(ev: SyntheticEvent) {
        const {value} = ev.target as HTMLInputElement;
        const filteredSearch = optionsHolder.current.filter(
            (i) =>
                selectedOptions?.find((j) => j === i.value) ||
                i.label.toLowerCase().includes(value.toLowerCase()) ||
                i.text?.toLowerCase().includes(value.toLowerCase()),
        );

        setOptions(() => [...filteredSearch]);
    }

    const handleCheckboxChange = (event: any) => {
        if (!event) {
            return;
        }
        const {value, checked} = event.target as HTMLInputElement;

        setSelectedOptions((prevSelected = []) => {
            const updated = checked
                ? [...prevSelected, value]
                : prevSelected.filter((option) => option !== value);

            if (onChange) {
                onChange(updated.length ? updated : undefined);
            }

            return updated.length ? updated : undefined;
        });
    };

    return (
        <Root>
            {searchable && (
                <SearchWrapper>
                    <InputLabel
                        placeholder={placeholder}
                        name={name}
                        onChange={searchByCheckboxes}
                    />
                    {/* <CustomInputLabel>
                        <CustomInput
                            type="text"
                            placeholder={placeholder ?? ''}
                            name={name}
                            onChange={searchByCheckboxes}
                        />
                        <LabelIcon />
                    </CustomInputLabel> */}
                </SearchWrapper>
            )}
            <Container>
                {searchOptions.map((i, id) => {
                    const {label, text} = i;
                    return (
                        <Checkbox
                            sizes={{width: 16, height: 16}}
                            key={i.id ?? id}
                            id={i.value as string}
                            value={i.value}
                            checked={selectedOptions?.includes(i.value)}
                            onChange={handleCheckboxChange}
                            isList={true}
                        >
                            <CheckboxItemLine>
                                {label}
                                {text && <AddressSpan>{text}</AddressSpan>}
                            </CheckboxItemLine>
                        </Checkbox>
                    );
                })}
            </Container>
        </Root>
    );
};
